import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { combineReducers } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { accessRequestApi } from 'src/services/AccessRequest';
import { codeListApi } from 'src/services/CodelistData';
import { confirmationVisitApi } from 'src/services/ConfirmationLetter';
import { doaApi } from 'src/services/DOA';
import { dataReviewApi } from 'src/services/DataReview';
import { drugAccountabilityApi } from 'src/services/DrugAccountability';
import { emrEvaluationApi } from 'src/services/EMREvaluation';
import { essentailDocsApi } from 'src/services/EssentialDocs';
import { form1572Api } from 'src/services/Form1572';
import { imvCheckListApi } from 'src/services/IMVCheckList';
import { imvFollowUpLetterApi } from 'src/services/IMVFollowUpLetter';
import { imvReportApi } from 'src/services/IMVReport';
import { ipManagementApi } from 'src/services/IPmanagement';
import { milestoneQueryApi } from 'src/services/MilestoneQueries';
import { milestoneQueryResponseApi } from 'src/services/MilestoneQueryResponse';
import { milestoneTrackingApi } from 'src/services/MilestoneTracking';
import { monitoringVisitLogApi } from 'src/services/MonitoringVisitLog';
import { noteToFileApi } from 'src/services/NoteToFile';
import { overViewApi } from 'src/services/Overview';
import { personnelApi } from 'src/services/Personnel';
import { queryApi } from 'src/services/Queries';
import { queryResponseApi } from 'src/services/QueryResponse';
import { sivConfirmationLetterApi } from 'src/services/SIVConfirmationLetter';
import { sivFollowupLetterAPI } from 'src/services/SIVFollowupLetterAPI';
import { siteContactInfoApi, siteContactInfoSysAdminApi } from 'src/services/SiteContactInfo';
import { siteStudyPersonnelApi } from 'src/services/SiteStudyPersonnel';
import { sitesApi } from 'src/services/Sites';
import { sivChecklistApi } from 'src/services/SivChecklist';
import { sivReportApi } from 'src/services/SivReport';
import { sqChecklistApi } from 'src/services/SqChecklist';
import { sqReportApi } from 'src/services/SqReport';
import { startupPacketApi } from 'src/services/StartupPacket';
import { studyApi } from 'src/services/Study';
import { studyLogApi } from 'src/services/StudyLogs';
import { subjectTrackingApi } from 'src/services/SubjectTracking';
import { subjectTrackingDetailsAPI } from 'src/services/SubjectTrackingDetails';
import { summaryDashboardApi } from 'src/services/SummaryDashboard';
import { trainingApi } from 'src/services/TrainingLog';
import { userGroupManagement } from 'src/services/UserGroupManagement';
import { utilsApi, utilsSysAdminApi } from 'src/services/Utils';
import { codeList } from 'src/services/codeList';
import { dataMonitoringApi } from 'src/services/dataMonitoring';
import { decisionAPI } from 'src/services/decisionData';
import { eligiblePatientAPI } from 'src/services/eligiblePatients';
import { emailActivityAPI } from 'src/services/emailActivityAPI';
import { etmfDocLevelApi } from 'src/services/etmfDocLevel';
import { isfDocLevelApi } from 'src/services/isfDocLevel';
import { issueLogApi } from 'src/services/issueLog';
import { monitoringEventAPI } from 'src/services/monitoringEvent';
import { patientDetailsAPI } from 'src/services/patientDetails';
import { protocolDeviationslogAPI } from 'src/services/protocolDeviationsLog';
import { protocolQALogApi } from 'src/services/protocolQALogs';
import { sqConfirmationLetterApi } from 'src/services/sqConfirmationLetterAPI';
import { sqFollowupLetterApi } from 'src/services/sqFollowupLetterAPI';
import { subjectToolkitAPI } from 'src/services/subjectToolkit';
import { toolkitFormAPI } from 'src/services/toolkitForms';
import { trailNotebookCRF } from 'src/services/trailNotebookCRF';
import { tsdaIntegrationAPI } from 'src/services/tsdaIntegrationApis';
import { workareaApi } from 'src/services/workarea';
import { accessRequest } from './AccessRequest';
import { crfForms } from './CrfFormsAction';
import { dialog } from './Dialog';
import { verifyFields } from './FormFieldsVerified';
import { loader } from './Loader';
import { message } from './Message';
import { navigationPath } from './Navigation';
import { personnel } from './Personnel';
import { roles } from './Roles';
import { selectedHierarchy } from './SelectedHierarchy';
import { selectedIntrialPatientInfo } from './SelectedIntrialPatient';
import { selectedSubjectInfo } from './SelectedSubject';
import { site } from './Site';
import { siteConatctInfo } from './SiteConatctInfo';
import { siteStudyPersonnel } from './SiteStudyPersonnel';
import { tabs } from './Tabs';
import { user } from './User';
import { codelistData } from './codelistData';
import confirmExitValueReducer from './confirmExitValue';
import confirmExitPopupValReducer from './confirmPopupVal';
import { selectedEMR } from './selectedEMR';
import { selectedPortalApp } from './selectedPortalApp';
import selectedStudyIdReducer from './selectedStudyId';
import selectedsitePersonnelReducer from './sitePersonnelCheckbox';
import selectedsiteReducer from './siteselected';
import sitestudypersonnelDataReducer from './sitestudypersonnelData';
import settingsReducer from './snackbarMessage';
import { sqConfirmationLetter } from './sqConfirmationLetter';
import { feasibility } from './feasibility';
import { sqCheckList } from './sqCheckList';
import { sqReport } from './sqReport';
import { eSingApi } from 'src/services/ESignAPI';
import { feasibilityFormAPI } from 'src/services/feasibility';
import { eSignSiteApi } from 'src/services/EsignSiteAPI';
import { sivCheckList } from './sivCheckList';
import { sivReport } from './sivReport';
import { preScreenGridRowsData } from './preScreenGridRowsData';
import { imvChecklist } from './imvChecklist';
import { imvReport } from './imvReport';
import { drugSupplyApi, masterListApi } from 'src/services/DrugSupply';
import { drugSupplySlice } from './drugSupplySlice';
const rootReducer = combineReducers({
  selectedSite: selectedsiteReducer,
  selectedStudyId: selectedStudyIdReducer,
  selectedsitepersonnel: selectedsitePersonnelReducer,
  confirmexitvalue: confirmExitValueReducer,
  confirmexitpopupval: confirmExitPopupValReducer,
  settings: settingsReducer,
  sitestudypersonnelData: sitestudypersonnelDataReducer
});

export { rootReducer };

export const store = configureStore({
  reducer: {
    selectedSite: selectedsiteReducer,
    selectedStudyId: selectedStudyIdReducer,
    selectedsitepersonnel: selectedsitePersonnelReducer,
    confirmexitvalue: confirmExitValueReducer,
    confirmexitpopupval: confirmExitPopupValReducer,
    settings: settingsReducer,
    sitestudypersonnelData: sitestudypersonnelDataReducer,
    [sitesApi.reducerPath]: sitesApi.reducer,
    [siteStudyPersonnelApi.reducerPath]: siteStudyPersonnelApi.reducer,
    [studyApi.reducerPath]: studyApi.reducer,
    [personnelApi.reducerPath]: personnelApi.reducer,
    [accessRequestApi.reducerPath]: accessRequestApi.reducer,
    [queryApi.reducerPath]: queryApi.reducer,
    [queryResponseApi.reducerPath]: queryResponseApi.reducer,
    [milestoneQueryApi.reducerPath]: milestoneQueryApi.reducer,
    [milestoneQueryResponseApi.reducerPath]: milestoneQueryResponseApi.reducer,
    [codeListApi.reducerPath]: codeListApi.reducer,
    [utilsApi.reducerPath]: utilsApi.reducer,
    [userGroupManagement.reducerPath]: userGroupManagement.reducer,
    roles: roles.reducer,
    site: site.reducer,
    selectedSubjectInfo: selectedSubjectInfo.reducer,
    selectedPortalApp: selectedPortalApp.reducer,
    siteConatctInfo: siteConatctInfo.reducer,
    selectedEMR: selectedEMR.reducer,
    tabs: tabs.reducer,
    message: message.reducer,
    user: user.reducer,
    dialog: dialog.reducer,
    loader: loader.reducer,
    personnel: personnel.reducer,
    siteStudyPersonnel: siteStudyPersonnel.reducer,
    accessRequest: accessRequest.reducer,
    [sivChecklistApi.reducerPath]: sivChecklistApi.reducer,
    navigationPath: navigationPath.reducer,
    [sivReportApi.reducerPath]: sivReportApi.reducer,
    [workareaApi.reducerPath]: workareaApi.reducer,
    dataReviewApi: dataReviewApi.reducer,
    issueLogApi: issueLogApi.reducer,
    protocolQALogApi: protocolQALogApi.reducer,
    decisionAPI: decisionAPI.reducer,
    [studyLogApi.reducerPath]: studyLogApi.reducer,
    [milestoneTrackingApi.reducerPath]: milestoneTrackingApi.reducer,
    [etmfDocLevelApi.reducerPath]: etmfDocLevelApi.reducer,
    [isfDocLevelApi.reducerPath]: isfDocLevelApi.reducer,
    [imvCheckListApi.reducerPath]: imvCheckListApi.reducer,
    [dataMonitoringApi.reducerPath]: dataMonitoringApi.reducer,
    [subjectTrackingDetailsAPI.reducerPath]: subjectTrackingDetailsAPI.reducer,
    [siteContactInfoApi.reducerPath]: siteContactInfoApi.reducer,
    [siteContactInfoSysAdminApi.reducerPath]: siteContactInfoSysAdminApi.reducer,
    [startupPacketApi.reducerPath]: startupPacketApi.reducer,
    [sqChecklistApi.reducerPath]: sqChecklistApi.reducer,
    [sqReportApi.reducerPath]: sqReportApi.reducer,
    [essentailDocsApi.reducerPath]: essentailDocsApi.reducer,
    [ipManagementApi.reducerPath]: ipManagementApi.reducer,
    [doaApi.reducerPath]: doaApi.reducer,
    [trainingApi.reducerPath]: trainingApi.reducer,
    [drugAccountabilityApi.reducerPath]: drugAccountabilityApi.reducer,
    [form1572Api.reducerPath]: form1572Api.reducer,
    [overViewApi.reducerPath]: overViewApi.reducer,
    verifyFields: verifyFields.reducer,
    CRFForms: crfForms.reducer,
    codeList: codeList.reducer,
    codelistData: codelistData.reducer,
    [subjectTrackingApi.reducerPath]: subjectTrackingApi.reducer,
    [tsdaIntegrationAPI.reducerPath]: tsdaIntegrationAPI.reducer,
    [protocolDeviationslogAPI.reducerPath]: protocolDeviationslogAPI.reducer,
    [utilsSysAdminApi.reducerPath]: utilsSysAdminApi.reducer,
    [imvReportApi.reducerPath]: imvReportApi.reducer,
    [monitoringEventAPI.reducerPath]: monitoringEventAPI.reducer,
    [imvFollowUpLetterApi.reducerPath]: imvFollowUpLetterApi.reducer,
    [confirmationVisitApi.reducerPath]: confirmationVisitApi.reducer,
    [sqConfirmationLetterApi.reducerPath]: sqConfirmationLetterApi.reducer,
    [sivConfirmationLetterApi.reducerPath]: sivConfirmationLetterApi.reducer,
    sqConfirmationLetter: sqConfirmationLetter.reducer,
    [sqFollowupLetterApi.reducerPath]: sqFollowupLetterApi.reducer,
    selectedHierarchy: selectedHierarchy.reducer,
    SelectedIntrialPatientInfo: selectedIntrialPatientInfo.reducer,
    [eligiblePatientAPI.reducerPath]: eligiblePatientAPI.reducer,
    [patientDetailsAPI.reducerPath]: patientDetailsAPI.reducer,
    [subjectToolkitAPI.reducerPath]: subjectToolkitAPI.reducer,
    [toolkitFormAPI.reducerPath]: toolkitFormAPI.reducer,
    [trailNotebookCRF.reducerPath]: trailNotebookCRF.reducer,
    [sivFollowupLetterAPI.reducerPath]: sivFollowupLetterAPI.reducer,
    [monitoringVisitLogApi.reducerPath]: monitoringVisitLogApi.reducer,
    [emrEvaluationApi.reducerPath]: emrEvaluationApi.reducer,
    [emailActivityAPI.reducerPath]: emailActivityAPI.reducer,
    [noteToFileApi.reducerPath]: noteToFileApi.reducer,
    [summaryDashboardApi.reducerPath]: summaryDashboardApi.reducer,
    feasibility: feasibility.reducer,
    imvChecklist: imvChecklist.reducer,
    imvReport: imvReport.reducer,
    [eSingApi.reducerPath]: eSingApi.reducer,
    [feasibilityFormAPI.reducerPath]: feasibilityFormAPI.reducer,
    [eSignSiteApi.reducerPath]: eSignSiteApi.reducer,
    sqReport: sqReport.reducer,
    sqCheckList: sqCheckList.reducer,
    sivCheckList: sivCheckList.reducer,
    sivReport: sivReport.reducer,
    preScreenGridRowsData: preScreenGridRowsData.reducer,
    //sqCheckList:sqCheckList.reducer,
    //sqReport:sqReport.reducer
    masterListApi: masterListApi.reducer,
    drugSupplyApi: drugSupplyApi.reducer,
    drugSupplySlice: drugSupplySlice.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      sitesApi.middleware,
      siteStudyPersonnelApi.middleware,
      studyApi.middleware,
      personnelApi.middleware,
      accessRequestApi.middleware,
      sivChecklistApi.middleware,
      imvCheckListApi.middleware,
      dataReviewApi.middleware,
      issueLogApi.middleware,
      protocolQALogApi.middleware,
      studyLogApi.middleware,
      milestoneTrackingApi.middleware,
      etmfDocLevelApi.middleware,
      isfDocLevelApi.middleware,
      dataMonitoringApi.middleware,
      subjectTrackingDetailsAPI.middleware,
      utilsApi.middleware,
      userGroupManagement.middleware,
      queryApi.middleware,
      queryResponseApi.middleware,
      milestoneQueryApi.middleware,
      milestoneQueryResponseApi.middleware,
      decisionAPI.middleware,
      siteContactInfoApi.middleware,
      siteContactInfoSysAdminApi.middleware,
      startupPacketApi.middleware,
      sqChecklistApi.middleware,
      sqReportApi.middleware,
      essentailDocsApi.middleware,
      ipManagementApi.middleware,
      doaApi.middleware,
      trainingApi.middleware,
      form1572Api.middleware,
      drugAccountabilityApi.middleware,
      overViewApi.middleware,
      sivReportApi.middleware,
      workareaApi.middleware,
      codeListApi.middleware,
      codeList.middleware,
      subjectTrackingApi.middleware,
      tsdaIntegrationAPI.middleware,
      protocolDeviationslogAPI.middleware,
      utilsSysAdminApi.middleware,
      imvReportApi.middleware,
      monitoringEventAPI.middleware,
      imvFollowUpLetterApi.middleware,
      confirmationVisitApi.middleware,
      sqConfirmationLetterApi.middleware,
      sqFollowupLetterApi.middleware,
      eligiblePatientAPI.middleware,
      patientDetailsAPI.middleware,
      subjectToolkitAPI.middleware,
      toolkitFormAPI.middleware,
      trailNotebookCRF.middleware,
      sivConfirmationLetterApi.middleware,
      sqFollowupLetterApi.middleware,
      sivFollowupLetterAPI.middleware,
      monitoringVisitLogApi.middleware,
      emrEvaluationApi.middleware,
      emailActivityAPI.middleware,
      noteToFileApi.middleware,
      summaryDashboardApi.middleware,
      eSingApi.middleware,
      feasibilityFormAPI.middleware,
      eSignSiteApi.middleware,
      masterListApi.middleware,
      drugSupplyApi.middleware
    )
});

type AppAction = Parameters<typeof rootReducer>[1];
export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;
export type AppThunk<A extends AppAction> = ThunkAction<void, AppState, unknown, A>;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;

export type RootState = ReturnType<typeof store.getState>;
